export * from './confirmation';
export * from './new-project';
export * from './project-configuration';
export * from './sub-account-selection';

import './managed-machine-project.scss';
